import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

export const i18n = new VueI18n({
	locale: process.env.VUE_APP_DEFAULT_LANG,
	fallbackLocale: process.env.VUE_APP_DEFAULT_LANG,
	silentTranslationWarn: true,
	silentFallbackWarn: true
})

i18n._path.getPathValue = function (obj, path) {
	if (obj === null && typeof obj === 'object') { return null }

	var paths = [path];
	if (paths.length === 0) {
		return null
	} else {
		var length = paths.length;
		var last = obj;
		var i = 0;
		while (i < length) {
			var value = last[paths[i]];
			if (value === undefined) {
				return null
			}
			last = value;
			i++;
		}

		return last
	}
};

export default i18n
